import axios from 'axios';

const baseURL = (process.env.VUE_APP_APPOINTMENT_DEFAULTS_API_URL || '').trim();
const client = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: false,
  withXSRFToken: false,
});

// axios.create inherits global defaults, including an existing CRM login.
client.interceptors.request.use(config => {
  config.headers.delete('Authorization');
  config.headers.delete('Cookie');
  config.auth = undefined;
  config.params = undefined;
  return config;
});

let inFlight = null;

function getAppointmentDefault(field) {
  if (!baseURL) {
    return Promise.reject(new Error('Missing VUE_APP_APPOINTMENT_DEFAULTS_API_URL'));
  }
  if (!inFlight) {
    const request = { fields: {} };
    request.response = client.get('/appointment-defaults')
      .then(response => response.data && response.data.data)
      .finally(() => { if (inFlight === request) inFlight = null; });
    inFlight = request;
  }
  if (!inFlight.fields[field]) {
    inFlight.fields[field] = inFlight.response.then(data => {
      const value = data && data[field];
      if (typeof value !== 'string' || !value.trim()) {
        throw new Error('Invalid appointment default');
      }
      return value;
    });
  }
  return inFlight.fields[field];
}

export function getAppointmentDefaultBookingNote() {
  return getAppointmentDefault('default_booking_note');
}

export function getAppointmentDefaultNotePlaceholder() {
  return getAppointmentDefault('default_note_placeholder');
}
